import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';

import { LazyMapsAPILoaderConfigLiteral } from '@duxor/agm-core';
import { ConfigService } from '../../../core/common/public_api';

@Injectable()
export class GoogleMapsConfig implements LazyMapsAPILoaderConfigLiteral {
    public apiKey: string;
    public libraries: string[];

    constructor(private readonly configService: ConfigService<any>) {
        this.init();
    }

    private init(): void {
        const apiKey$: Observable<string | undefined | null> = this.configService
            .getConfig()
            .pipe(map(config => config.googleApiKey));

        apiKey$.pipe(take(1)).subscribe(apiKey => {
            if (!apiKey) {
                console.warn('Google maps api key not provided in library config');
                return;
            }

            this.apiKey = apiKey;
            this.libraries = ['places'];
        });
    }
}
